import {GridMediaItem} from '@Components/base-grid/components/grid-media-item';
import type {ReactElement} from 'react';
import {useState} from 'react';
import {isStockItemPredominantlyWhite} from '@Libraries/pmw-stock-media-library';
import styles from '@Components/base-grid/components/grid-sticker-item/grid-sticker-item.module.scss';
import type {GridStillStickerItemProps} from '@Components/base-grid/components/grid-still-sticker-item/grid-still-sticker-item.types';
export function GridStillStickerItem({...props}: GridStillStickerItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasGrayBackground, setHasGrayBackground] = useState(false);
  return (
    <GridMediaItem
      {...props}
      paddedThumb={true}
      isImageLoaded={isImageLoaded}
      hasGrayBackground={hasGrayBackground}
      thumb={
        <img
          onLoad={(): void => {
            setIsImageLoaded(true);
            void isStockItemPredominantlyWhite(props.thumbSrc).then(setHasGrayBackground);
          }}
          src={props.thumbSrc}
          className={`radius-12 ${styles.thumb}`}
          alt={window.i18next.t('pmwjs_image')}
          draggable="false"
          loading="lazy"
        />
      }
    />
  );
}
